// src/helpers/rutaOcrDocumento.js
import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE || "https://backre-miami.us-3.evennode.com";

const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const API = axios.create({
  baseURL: BASE_URL,
  timeout: 90000,
});

const p = (path) => `/${String(path || "").replace(/^\/+/, "")}`;

const getToken = () => localStorage.getItem("token") || "";

const authHeaders = () => {
  const token = getToken();
  return token ? { token } : {};
};

const clean = (v) => String(v ?? "").trim();

const unwrapOcr = (data) => {
  if (!data) return null;
  if (data?.datos) return data.datos;
  if (data?.data?.datos) return data.data.datos;
  return data;
};

/**
 * Lee un documento con OCR/IA.
 *
 * Uso con archivo:
 * leerDocumentoClienteOCR({
 *   file,
 *   tipoDocumento: "frente",
 *   destino: "clienteCompra",
 * })
 *
 * Uso con URL ya guardada:
 * leerDocumentoClienteOCR({
 *   imageUrl: cliente.documentos.frente.url,
 *   tipoDocumento: "frente",
 *   destino: "clienteCompra",
 * })
 */
export async function leerDocumentoClienteOCR({
  file = null,
  imageUrl = "",
  tipoDocumento = "frente",
  destino = "clienteCompra",
  signal,
} = {}) {
  if (!file && !clean(imageUrl)) {
    throw new Error("Debe seleccionar una imagen o enviar una URL.");
  }

  const formData = new FormData();

  if (file) {
    formData.append("documento", file);
  }

  if (clean(imageUrl)) {
    formData.append("imageUrl", clean(imageUrl));
  }

  formData.append("tipoDocumento", clean(tipoDocumento) || "frente");
  formData.append("destino", clean(destino) || "clienteCompra");

  const res = await API.post(p("ocr/documento-cliente"), formData, {
    signal,
    headers: {
      ...authHeaders(),
      // No seteamos manualmente Content-Type con boundary.
      // Axios/browser lo arma correctamente para FormData.
    },
  });

  return {
    ...res.data,
    datos: unwrapOcr(res.data),
  };
}

/**
 * Helper para aplicar OCR al estado del comprador en Venta Rápida.
 * Devuelve solo los campos compatibles con clienteCompra.
 */
export function mapOcrAClienteCompra(datos = {}) {
  const comprador = datos?.comprador || {};
  const direccion = datos?.direccion || {};

  const patch = {};

  if (comprador.apellido1) patch.apellido1 = comprador.apellido1;
  if (comprador.apellido2) patch.apellido2 = comprador.apellido2;
  if (comprador.nombre) patch.nombre = comprador.nombre;
  if (comprador.dni) patch.dni = comprador.dni;

  if (direccion.domicilio) patch.domicilio = direccion.domicilio;
  if (direccion.direccion2) patch.direccion2 = direccion.direccion2;
  if (direccion.ciudad) patch.ciudad = direccion.ciudad;
  if (direccion.estado) patch.estado = direccion.estado;
  if (direccion.zipCode) patch.zipCode = direccion.zipCode;
  if (direccion.pais) patch.pais = direccion.pais;

  return patch;
}